import gql from 'graphql-tag';
import { useQuery as defaultUseQuery } from '@apollo/react-hooks';

import { ApolloInjection } from '@zapier/payment/src/ts-types';
import { currentUserQuery as CurrentUser } from './types/currentUserQuery';

export const currentUserQuery = gql`
  query currentUserQuery {
    currentUserV2 {
      id
    }
  }
`;

type Props = {
  skip?: boolean;
} & ApolloInjection;

export const useCurrentUser = (props: Props) => {
  const useQuery = props.useQuery || defaultUseQuery;
  const { data, error, loading } = useQuery<CurrentUser>(currentUserQuery, {
    skip: props.skip || false,
  });

  return {
    currentUser: data?.currentUserV2,
    error: error ? 'Error loading current user information.' : undefined,
    isLoading: loading,
  };
};

export const useCurrentUserMock = {
  request: {
    query: currentUserQuery,
  },
  result: {
    data: {
      currentUserV2: {
        __typename: 'UserV2',
        id: '1',
      },
    },
  },
};
